
import {
  defineComponent, ref, computed,
} from '@vue/composition-api';
import SizeSelectorsMulti from './SizeSelectorsMulti.vue';

type SelectedValue = { number: string };

const numberPersonText = ['First', 'Second', 'Third', 'Fourth'];

export default defineComponent({
  name: 'SizingStep',
  components: {
    SizeSelectorsMulti,
  },
  setup() {
    // @ts-ignore
    const { $store } = useNuxtApp();
    const packageSelected = computed(() => $store.getters.packageSelected);
    const pairsNeeded = computed(() => packageSelected.value?.variants?.length - 1);
    const pairList = computed(() => Array.from({ length: pairsNeeded.value }, (_, index) => [
      {
        id: 'S',
        uid: `small_${index}`,
        name: 'Small',
      },
      {
        id: 'L',
        uid: `large_${index}`,
        name: 'Large',
      },
    ]));

    const selectedValues = ref<SelectedValue[]>([]);
    const updateSizeValue = (index: number, size: string) => {
      selectedValues.value.splice(index, 1, size.value); // Update the selected value for the corresponding index
      const sortedValues = [...selectedValues.value].sort((a, b) => {
        if (a === 'S' && b === 'L') return -1;
        if (a === 'L' && b === 'S') return 1;
        return 0;
      }).join('');

      const itemToAdd = packageSelected.value.variants.find((variant) => variant.uid.includes(sortedValues));
      $store.commit('SET_PACKAGE_BUILDER', { step: 'sizeVariant', productData: itemToAdd });
    };
    return {
      numberPersonText,
      updateSizeValue,
      selectedValues,
      pairList,
    };
  },
});
